import firebase from "firebase/app"
import "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyAse8FiXZ61WFD3DOQIm6rbt3mWEDdQfSQ",
  authDomain: "anjuishiyama.firebaseapp.com",
  projectId: "anjuishiyama",
  storageBucket: "anjuishiyama.appspot.com",
  messagingSenderId: "877999513534",
  appId: "1:877999513534:web:b028e6ee9a80cebdcd63ef",
  measurementId: "G-YZ7MQKV6RH",
}

firebase.initializeApp(firebaseConfig)

export const db = firebase.firestore()
export default firebase
